import { render, staticRenderFns } from "./api.vue?vue&type=template&id=2779d856&"
import script from "./api.vue?vue&type=script&lang=js&"
export * from "./api.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2779d856')) {
      api.createRecord('2779d856', component.options)
    } else {
      api.reload('2779d856', component.options)
    }
    module.hot.accept("./api.vue?vue&type=template&id=2779d856&", function () {
      api.rerender('2779d856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/components/container/api.vue"
export default component.exports